import { CycleType } from '@wix/ambassador-premium-purchase-platform-v1-offering/types';
import { createApiClient } from '@wix/premium-fed-sdk/@apis-infra-react';
import { PurchaseOfferingApiConfig } from '@wix/premium-purchase-platform/@sdk';
import { BROKER_FEE_PRODUCT_ID } from '../../constants/broker';
import { BrokerFeePriceErrors, getBrokerFeeFormattedPrice } from '../../utils/brokerFeePrice';
const PurchaseOfferingApiClient = createApiClient(PurchaseOfferingApiConfig);
export const getBrokerFeePrice = async _ref => {
  let httpClient = _ref.httpClient;
  const _await$PurchaseOfferi = await PurchaseOfferingApiClient.query.getPurchaseProduct({
      httpClient,
      request: {
        productId: BROKER_FEE_PRODUCT_ID,
        cycle: {
          cycleType: CycleType.ONE_TIME
        }
      }
    }),
    product = _await$PurchaseOfferi.product;
  const formattedPrice = getBrokerFeeFormattedPrice(product);
  if (!formattedPrice) {
    throw new Error(BrokerFeePriceErrors.NO_ONE_TIME_PRICE);
  }
  return {
    formattedPrice
  };
};
//# sourceMappingURL=getBrokerFeePrice.js.map